ele.keys = (function() {
	
	return {
		BACKSPACE: 8,
		A: 65,
		
		//disable the backspace key so you don't accidently navigate away
		//FYI input[type=string] is for the Assembler. Well aware it's a made up input type
		disableBackspace: function() {
	 		$(document).keydown(function(e) {
	 			if (
	 				e.which == ele.keys.BACKSPACE &&
                    (document.activeElement == null ||
	 				!($(document.activeElement).prop("tagName").toUpperCase() == "INPUT" ||
	 				$(document.activeElement).prop("tagName").toUpperCase() == "TEXTAREA" ||
	 				$(document.activeElement).prop("contenteditable") == "true"))
	 			) {
	 				e.preventDefault();
	 			}
	 		});
		},

		disableSelectAll:function() {
			$(document).keydown(function(e) {
	 			if (
	 				e.keyCode == ele.keys.A &&
                    (document.activeElement == null ||
	 				!($(document.activeElement).prop("tagName").toUpperCase() == "INPUT" ||
	 				$(document.activeElement).prop("tagName").toUpperCase() == "TEXTAREA" ||
	 				$(document.activeElement).prop("contenteditable") == "true"))
	 			) {
	 				e.preventDefault();
	 			}
	 		});
			
			
		}
	};

})();